import ArrowDown from '../assets/images/arrow-down.png';
import ClassesIcon from '../assets/images/classess.png';
import Coaching from '../assets/images/coaching.png';
import Communication from '../assets/images/communication.png';
import DashboardIcon from '../assets/images/dashboard.png';
import MembersIcon from '../assets/images/members.png';
import AvatarIcon from '../assets/images/Avatar.png';
import LiveIcon from '../assets/images/liveIcon.png';

interface MySvgProps {
    width?: number;
    height?: number;
    fill?: string;
}

const classesPrice = [
    0, 9.99, 14.99, 19.99, 24.99, 29.99, 34.99, 39.99, 44.99, 49.99, 54.99, 59.99, 64.99, 69.99,
    74.99, 79.99, 84.99, 89.99, 94.99, 99.99, 109.99, 119.99, 129.99, 139.99, 149.99, 159.99,
    169.99, 179.99, 189.99, 199.99, 209.99, 219.99, 229.99, 239.99, 249.99, 259.99, 269.99, 279.99,
    289.99, 299.99,
].map(item => {
    return {
        purePrice:item,
        discountedPrice:0,
        validFrom:null,
        validTo:null
    }
});

const classesLevel = ["BEGINNER", "INTERMEDIATE", "ADVANCED", ];

const homeworkData = [
    {
        title:"How to Enhance Your Entrepreneurship",
        status:"Received",
        isEdit:"Answer",
        isHidden:false
    },
    {
        title:"How to Enhance Your Entrepreneurship",
        status:"Received",
        isEdit:"Answer",
        isHidden:false
    },

    {
        title:"How to Enhance Your Entrepreneurship",
        status:"Completed",
        isEdit:"View",
        isHidden:false
    },
    {
        title:"How to Enhance Your Entrepreneurship",
        status:"Completed",
        isEdit:"View",
        isHidden:false
    },
    {
        title:"How to Enhance Your Entrepreneurship",
        status:"Completed",
        isEdit:"View",
        isHidden:false
    }
]

const reviewData = [
    {
        title:"How to Enhance Your Entrepreneurship",
        status:"New",
        isEdit:"Reply",
        isHidden:false
    },
    {
        title:"How to Enhance Your Entrepreneurship",
        status:"New",
        isEdit:"Reply",
        isHidden:false
    },

    {
        title:"How to Enhance Your Entrepreneurship",
        status:"Completed",
        isEdit:"View",
        isHidden:false
    },
    {
        title:"How to Enhance Your Entrepreneurship",
        status:"Completed",
        isEdit:"View",
        isHidden:false
    },
    {
        title:"How to Enhance Your Entrepreneurship",
        status:"Completed",
        isEdit:"View",
        isHidden:false
    }
]

const qnaData = [
    {
        title:"How to Enhance Your Entrepreneurship",
        status:"New",
        isEdit:"Reply",
        isHidden:false
    },
    {
        title:"How to Enhance Your Entrepreneurship",
        status:"New",
        isEdit:"Reply",
        isHidden:false
    },

    {
        title:"How to Enhance Your Entrepreneurship",
        status:"Completed",
        isEdit:"View",
        isHidden:false
    },
    {
        title:"How to Enhance Your Entrepreneurship",
        status:"Completed",
        isEdit:"View",
        isHidden:false
    },
    {
        title:"How to Enhance Your Entrepreneurship",
        status:"Completed",
        isEdit:"View",
        isHidden:true
    }
]

const chapter = [
    "Introduction",
    "Chapter 1",
    "Chapter 2",
    "Chapter 3",
    "Chapter 4",
    "Chapter 5",
    "Chapter 6",
];

export const returnChapterId = (category) => {
    switch (category) {
        case "INTRODUCTION" : {
            return {
                orderNumber:0,
                chapterType:"INTRODUCTION"
            }
        }
        case "CHAPTER" : {
            return {
                orderNumber:1,
                chapterType:"CHAPTER"
            }
        }
        case "CONCLUSION" : {
            return {
                orderNumber:2,
                chapterType:"CHAPTER"
            }
        }
    }
}

const hour = [
    "00",
]

const constCommon = {
    ICON: {
        SIDE_MENU: {
            Dashboard: DashboardIcon,
            ClassesIcon: ClassesIcon,
            Coaching: Coaching,
            Communication: Communication,
            Members: MembersIcon,
            AvatarIcon:AvatarIcon,
            LiveIcon:LiveIcon
        },
        ARROW: {
            DOWN: ArrowDown,
        },
    },
    CLASSES_PRICE: classesPrice,
    CLASSES_LEVEL: classesLevel,
    CLASESS_CHAPTER : chapter,
    TEST_DATA:{
        Homework:homeworkData,
        Review:reviewData,
        Qna:qnaData
    }
};

export { constCommon };
